import React from 'react'

const DL5000 = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Yokogawa</a>
                        <i class="fa fa-angle-right"></i>
                        <a href="/">Oscilloscopes</a>
                        <i class="fa fa-angle-right"></i>
                        <span>Mixed Signal Oscilloscope </span>
                        <i class="fa fa-angle-right"></i>
                        <span>DLM5000</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/dlm50.jpg' width={400} style={{ marginTop: "80px" }}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>DLM5000:</h2>
                        <p class="mbot25">
                            Combining a large, highly responsive touchscreen and a traditional oscilloscope panel,
                            the 4-to-8 channel DLM5000 mixed signal oscilloscope allows users to easily navigate
                            through a wealth of analysis features at the touch of their fingertips.
                        </p>
                        <p class="mbot25">
                            <img src='/img/dlm50Table.png' className='tableimg' />
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DL5000
